// Centralized mock data for Barangay San Isidro, Cainta, Rizal.
// All data is static / frontend-only. Admin flows persist to localStorage.

export const BARANGAY = {
  name: 'Barangay San Isidro',
  municipality: 'Cainta',
  province: 'Rizal',
  fullName: 'Barangay San Isidro, Cainta, Rizal',
  tagline: 'Serbisyong Mabilis, Malinaw, at May Malasakit',
  tagline_en: 'Fast, transparent, and compassionate public service',
  hotline: '(02) 8655-1234',
  email: 'info@brgysanisidro-cainta.gov.ph',
  address: 'San Isidro Barangay Hall, A. Bonifacio Ave., San Isidro, Cainta, Rizal 1900',
  facebook: 'https://www.facebook.com/OneCainta.SanIsidro',
  officeHours: 'Monday – Friday  ·  8:00 AM – 5:00 PM',
  saturdayHours: 'Saturday  ·  8:00 AM – 12:00 PM',
  founded: 1995,
  population: '28,450+',
  households: '6,820+',
  puroks: 7,
};

export const BRAND = {
  logoUrl: '/site-logo.svg',
  captainPhotoUrl: '/punong-barangay.jpg',
  bannerUrl: 'https://customer-assets.emergentagent.com/job_b065420d-1f20-4a2b-b0db-a3ed0cb5717d/artifacts/3zviz5v8_image.png',
  communityHeroUrl: 'https://images.unsplash.com/photo-1586012606305-b874330e25fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxQaGlsaXBwaW5lJTIwY29tbXVuaXR5fGVufDB8fHx8MTc3NzcwNTc0Mnww&ixlib=rb-4.1.0&q=85',
  volunteersUrl: 'https://images.unsplash.com/photo-1739525346229-6e122171f68d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxGaWxpcGlubyUyMHZvbHVudGVlcnN8ZW58MHx8fHwxNzc3NzA1NzQyfDA&ixlib=rb-4.1.0&q=85',
  cleanupUrl: 'https://images.unsplash.com/photo-1616680214452-df6901ae5727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxGaWxpcGlubyUyMHZvbHVudGVlcnN8ZW58MHx8fHwxNzc3NzA1NzQyfDA&ixlib=rb-4.1.0&q=85',
  streetUrl: 'https://images.unsplash.com/photo-1641791446366-b10e4446cd9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxQaGlsaXBwaW5lJTIwc3RyZWV0fGVufDB8fHx8MTc3NzcwNTc0Mnww&ixlib=rb-4.1.0&q=85',
  basketballUrl: 'https://images.pexels.com/photos/31091355/pexels-photo-31091355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  flagUrl: 'https://images.unsplash.com/photo-1669991504272-19c28fd98c15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxQaGlsaXBwaW5lJTIwZmxhZ3xlbnwwfHx8fDE3Nzc3MDU3NDJ8MA&ixlib=rb-4.1.0&q=85',
};

export const CAPTAIN = {
  name: 'Architect Ric Licup',
  title: 'Punong Barangay',
  term: '2023 – 2026',
  photoUrl: BRAND.captainPhotoUrl,
  shortBio:
    'The Office of the Punong Barangay leads community planning, service delivery, and governance coordination focused on modern services, transparency, and public accountability.',
  message:
    'Mahal naming mga residente, ang Barangay Action Center na ito ay para mapabilis ang serbisyo, mapalapit ang barangay sa mamamayan, at maging malinaw ang bawat programa at proyekto para sa buong komunidad.',
  priorities: [
    { icon: 'ShieldCheck', title: 'Peace & Order', desc: '24/7 tanod patrols, streetlight coverage, and community watch across all 7 puroks.' },
    { icon: 'Leaf', title: 'Clean & Green', desc: 'Monthly clean-up drives, solid-waste segregation, and urban greening.' },
    { icon: 'HeartPulse', title: 'Health & Social Services', desc: 'Free medical missions, senior assistance, and barangay health workers on call.' },
    { icon: 'GraduationCap', title: 'Education & Livelihood', desc: 'Scholarship coordination, skills training, and job-matching for residents.' },
    { icon: 'Trophy', title: 'Youth & Sports', desc: 'Basketball leagues, leadership camps, and safe spaces for young residents.' },
    { icon: 'Siren', title: 'Disaster Preparedness', desc: 'Flood drills, evacuation readiness, and clear emergency response plans.' },
    { icon: 'FileCheck2', title: 'Transparent Governance', desc: 'Published reports, online services, and open office hours for every resident.' },
  ],
};

export const OFFICIALS = [
  { id: 'off-01', name: 'Architect Ric Licup', position: 'Punong Barangay', committee: 'Executive · Peace & Order', photo: BRAND.captainPhotoUrl },
  { id: 'off-02', name: 'Hon. Maria Elena Santos', position: 'Barangay Kagawad', committee: 'Health & Social Services', photo: 'https://i.pravatar.cc/300?img=47' },
  { id: 'off-03', name: 'Hon. Roberto Dela Cruz', position: 'Barangay Kagawad', committee: 'Infrastructure & Public Works', photo: 'https://i.pravatar.cc/300?img=12' },
  { id: 'off-04', name: 'Hon. Luz Mendoza', position: 'Barangay Kagawad', committee: 'Education & Scholarships', photo: 'https://i.pravatar.cc/300?img=45' },
  { id: 'off-05', name: 'Hon. Jose Villanueva', position: 'Barangay Kagawad', committee: 'Peace, Order & Safety', photo: 'https://i.pravatar.cc/300?img=33' },
  { id: 'off-06', name: 'Hon. Grace Aquino', position: 'Barangay Kagawad', committee: 'Women, Family & PWD Affairs', photo: 'https://i.pravatar.cc/300?img=48' },
  { id: 'off-07', name: 'Hon. Mark Rivera', position: 'Barangay Kagawad', committee: 'Livelihood & Cooperatives', photo: 'https://i.pravatar.cc/300?img=14' },
  { id: 'off-08', name: 'Hon. Paolo Bautista', position: 'Barangay Kagawad', committee: 'Environment & Sanitation', photo: 'https://i.pravatar.cc/300?img=11' },
  { id: 'off-09', name: 'Angelica Reyes', position: 'SK Chairperson', committee: 'Youth Development & Sports', photo: 'https://i.pravatar.cc/300?img=44' },
  { id: 'off-10', name: 'Ms. Corazon Vergara', position: 'Barangay Secretary', committee: 'Administration & Records', photo: 'https://i.pravatar.cc/300?img=49' },
  { id: 'off-11', name: 'Mr. Edgardo Lim', position: 'Barangay Treasurer', committee: 'Finance & Budget', photo: 'https://i.pravatar.cc/300?img=13' },
  { id: 'off-12', name: 'Atty. Rafael Cruz', position: 'Lupon Chairperson', committee: 'Katarungang Pambarangay', photo: 'https://i.pravatar.cc/300?img=15' },
];

export const ANNOUNCEMENTS = [
  {
    id: 'a01',
    title: 'Free Medical Mission — December 14, 2026 at the Barangay Covered Court',
    category: 'Health Advisory',
    date: '2026-12-02',
    pinned: true,
    summary: 'Libreng konsultasyon, gamot, at laboratoryo para sa lahat ng residente. Dalhin lamang ang valid ID at barangay clearance kung meron.',
    content: 'The Barangay San Isidro Health Committee, in partnership with the Cainta Municipal Health Office, will be conducting a free medical mission on December 14, 2026 from 8:00 AM to 4:00 PM at the Barangay Covered Court. Services include general consultation, free medicines, blood pressure monitoring, blood sugar screening, and basic laboratory tests. Priority will be given to senior citizens, PWDs, and pregnant women.',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1200&q=70',
  },
  {
    id: 'a02',
    title: 'Advisory: Water Service Interruption on Dec 7, Purok 3 & 4',
    category: 'Service Advisory',
    date: '2026-12-01',
    pinned: true,
    summary: 'Manila Water will be conducting pipe repair from 9 PM of Dec 6 to 5 AM of Dec 7. Residents advised to store water in advance.',
    content: 'Please be informed of a scheduled water service interruption affecting Purok 3 and Purok 4 due to pipe repair works by Manila Water. Residents are advised to store enough water for household needs during the interruption period.',
    image: null,
  },
  {
    id: 'a03',
    title: 'Barangay Assembly — Saturday, Dec 20 at 3:00 PM',
    category: 'Public Hearing / Assembly',
    date: '2026-11-28',
    pinned: false,
    summary: 'Open barangay assembly. Present: 2026 accomplishments, 2027 budget, and community Q&A.',
    content: 'All registered residents are invited to the quarterly barangay assembly. Agenda includes review of 2026 accomplishments, discussion of proposed 2027 barangay budget, and an open forum with barangay officials.',
    image: null,
  },
  {
    id: 'a04',
    title: 'Clean-Up Drive — December 10 (Purok 1, 2, 5)',
    category: 'Program Announcement',
    date: '2026-11-25',
    pinned: false,
    summary: 'Join our monthly clean-up drive. Volunteers will receive a certificate of participation.',
    content: 'Volunteers are encouraged to join our monthly Purok-wide clean-up drive. Assembly at 6:00 AM at the covered court. Snacks and certificates will be provided.',
    image: null,
  },
  {
    id: 'a05',
    title: 'Christmas Lantern Parade & Pasko sa Barangay',
    category: 'Program Announcement',
    date: '2026-11-20',
    pinned: false,
    summary: 'Annual Christmas parade at 5:00 PM on December 18, followed by caroling and gift-giving for 500 children.',
    content: 'Join the annual Pasko sa Barangay celebration featuring a lantern parade, community caroling, and gift-giving for 500 children from priority households.',
    image: null,
  },
  {
    id: 'a06',
    title: 'Holiday Schedule: Barangay Hall Office Hours',
    category: 'General Advisory',
    date: '2026-11-18',
    pinned: false,
    summary: 'Closed on Dec 24 (12NN onwards), Dec 25, Dec 31, and Jan 1. Emergency hotline remains 24/7.',
    content: 'Please note the adjusted office hours during the holiday season. Document processing resumes on January 2.',
    image: null,
  },
];

export const PROGRAMS = [
  {
    id: 'p01',
    title: 'Libreng Medical Mission at San Isidro',
    category: 'Health',
    date: '2026-12-14',
    time: '8:00 AM – 4:00 PM',
    location: 'Barangay Covered Court',
    slots: 300,
    registered: 142,
    image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=1200&q=70',
    description: 'Free medical consultation, medicines, BP monitoring, and basic lab tests. Priority to seniors, PWDs, and pregnant women.',
    requirements: 'Valid ID, barangay clearance (if available), vaccination card for children',
    contact: 'Barangay Health Center · (02) 8655-1235',
  },
  {
    id: 'p02',
    title: 'Livelihood Training: Food Processing & Packaging',
    category: 'Livelihood',
    date: '2026-12-16',
    time: '9:00 AM – 4:00 PM',
    location: 'Barangay Training Hall',
    slots: 40,
    registered: 28,
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1200&q=70',
    description: '3-day hands-on training in partnership with DTI & TESDA. Learn how to start a home-based food business.',
    requirements: 'Resident of San Isidro, 18+ years old, bring apron & hair cover',
    contact: 'Kagawad Mark Rivera · (02) 8655-1236',
  },
  {
    id: 'p03',
    title: 'Inter-Purok Basketball League 2026',
    category: 'Youth / SK',
    date: '2026-12-20',
    time: '4:00 PM onwards',
    location: 'Barangay Covered Court',
    slots: 140,
    registered: 140,
    image: BRAND.basketballUrl,
    description: 'Annual inter-purok basketball league. 7 teams, single round-robin. Opening ceremony at 3:30 PM.',
    requirements: 'Registered team roster, proof of residency',
    contact: 'SK Chair Angelica Reyes',
  },
  {
    id: 'p04',
    title: 'Senior Citizens Wellness Day',
    category: 'Senior Citizens',
    date: '2026-12-22',
    time: '8:00 AM – 12:00 NN',
    location: 'Senior Citizens Hall',
    slots: 120,
    registered: 88,
    image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&w=1200&q=70',
    description: 'Free check-up, light zumba, snacks, and distribution of social pension for qualified seniors.',
    requirements: 'Senior Citizen ID',
    contact: 'Senior Affairs Office',
  },
  {
    id: 'p05',
    title: 'Youth Leadership Summit',
    category: 'Youth / SK',
    date: '2027-01-10',
    time: '9:00 AM – 5:00 PM',
    location: 'Training Hall',
    slots: 60,
    registered: 24,
    image: 'https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=70',
    description: 'Full-day workshop on leadership, civic engagement, and public speaking for youth 15–25.',
    requirements: 'Ages 15–25, barangay resident',
    contact: 'SK Secretary',
  },
  {
    id: 'p06',
    title: 'Flood Preparedness Drill & Orientation',
    category: 'Disaster Preparedness',
    date: '2027-01-18',
    time: '7:00 AM – 11:00 AM',
    location: 'All Puroks (simultaneous)',
    slots: 500,
    registered: 86,
    image: 'https://images.unsplash.com/photo-1551448192-66c9cec05ff5?auto=format&fit=crop&w=1200&q=70',
    description: 'Community-wide drill and orientation on flood response, evacuation routes, and emergency kits.',
    requirements: 'Open to all residents',
    contact: 'BDRRMC',
  },
];

export const PROJECTS = [
  {
    id: 'pr01',
    name: 'Solar Streetlight Installation — Purok 2, 3 & 7',
    category: 'Peace & Order',
    status: 'Completed',
    location: 'Purok 2, 3, 7',
    startDate: '2026-08-15',
    completedDate: '2026-11-04',
    beneficiaries: '5,800 residents',
    description: '42 solar-powered LED streetlights installed across three puroks to improve night-time safety and reduce grid dependency.',
    image: BRAND.streetUrl,
  },
  {
    id: 'pr02',
    name: 'Drainage Cleaning & Canal Repair — Purok 4',
    category: 'Infrastructure',
    status: 'Completed',
    location: 'Purok 4, A. Bonifacio Ave.',
    startDate: '2026-09-10',
    completedDate: '2026-10-28',
    beneficiaries: '1,200 households',
    description: '320 linear meters of canal de-silted and reinforced, significantly reducing flooding during heavy rains.',
    image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&w=1200&q=70',
  },
  {
    id: 'pr03',
    name: 'CCTV Coverage Expansion',
    category: 'Peace & Order',
    status: 'Ongoing',
    location: 'All major entry points',
    startDate: '2026-10-01',
    targetDate: '2027-01-31',
    beneficiaries: 'Entire barangay',
    description: '18 additional CCTV units being installed at entry/exit points, major intersections, and the public market.',
    image: 'https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1200&q=70',
  },
  {
    id: 'pr04',
    name: 'Barangay Covered Court Repainting & Roof Repair',
    category: 'Facility Improvement',
    status: 'Completed',
    location: 'Barangay Covered Court',
    startDate: '2026-07-02',
    completedDate: '2026-09-12',
    beneficiaries: 'All residents',
    description: 'Full repainting, roof leak repair, and new scoreboard for the covered court.',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1200&q=70',
  },
  {
    id: 'pr05',
    name: 'Health Center Equipment Upgrade',
    category: 'Health',
    status: 'Ongoing',
    location: 'Barangay Health Center',
    startDate: '2026-11-05',
    targetDate: '2027-02-10',
    beneficiaries: '28,450 residents',
    description: 'New BP monitors, nebulizers, and examination tables procured. Digital records system in progress.',
    image: 'https://images.unsplash.com/photo-1519494140681-8b17d830a3e9?auto=format&fit=crop&w=1200&q=70',
  },
  {
    id: 'pr06',
    name: 'Road Concreting — Sitio Masikap Extension',
    category: 'Infrastructure',
    status: 'Planned',
    location: 'Sitio Masikap',
    startDate: '2027-02-01',
    targetDate: '2027-04-30',
    beneficiaries: '420 households',
    description: '280 linear meters of road to be concreted, including proper drainage alignment.',
    image: 'https://images.unsplash.com/photo-1523413555810-41fb01b5bdd0?auto=format&fit=crop&w=1200&q=70',
  },
];

export const ACCOMPLISHMENT_METRICS = [
  { label: 'Residents Served', value: 2430, icon: 'Users' },
  { label: 'Documents Processed', value: 850, icon: 'FileCheck' },
  { label: 'Concerns Received', value: 320, icon: 'Megaphone' },
  { label: 'Concerns Resolved', value: 285, icon: 'CheckCircle2' },
  { label: 'Projects Completed', value: 18, icon: 'Hammer' },
  { label: 'Programs Conducted', value: 42, icon: 'CalendarCheck' },
];

export const MONTHLY_ACCOMPLISHMENTS = [
  {
    id: 'm01',
    month: 'November 2026',
    summary: 'Focus on streetlight rollout, medical mission, and drainage clean-up ahead of the rainy-season review.',
    metrics: [
      { label: 'Documents Processed', value: 450 },
      { label: 'Residents Assisted', value: 120 },
      { label: 'Streetlights Repaired / Installed', value: 18 },
      { label: 'Clean-up Drives Conducted', value: 3 },
      { label: 'Medical Missions Completed', value: 2 },
      { label: 'Concerns Resolved', value: 35 },
    ],
    image: BRAND.volunteersUrl,
  },
  {
    id: 'm02',
    month: 'October 2026',
    summary: 'Drainage clean-up and CCTV planning took priority — paving the way for a drier rainy season.',
    metrics: [
      { label: 'Documents Processed', value: 412 },
      { label: 'Residents Assisted', value: 140 },
      { label: 'Drainage Meters Cleared', value: 320 },
      { label: 'Clean-up Drives Conducted', value: 2 },
      { label: 'Concerns Resolved', value: 42 },
    ],
    image: BRAND.cleanupUrl,
  },
  {
    id: 'm03',
    month: 'September 2026',
    summary: 'Back-to-school season — largest school-supply distribution in barangay history.',
    metrics: [
      { label: 'School Kits Distributed', value: 540 },
      { label: 'Scholarship Slots Awarded', value: 25 },
      { label: 'Documents Processed', value: 388 },
      { label: 'Concerns Resolved', value: 29 },
    ],
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1200&q=70',
  },
];

export const SERVICES = [
  {
    id: 's01',
    slug: 'barangay-clearance',
    title: 'Barangay Clearance',
    group: 'Personal Certificates',
    icon: 'FileCheck2',
    purpose: 'Employment, business permit, government transaction, legal requirement',
    requirements: ['Valid government-issued ID', 'Proof of residency (any utility bill)', 'Cedula / Community Tax Certificate'],
    fee: 'Php 50.00',
    processing: '1 – 2 working days',
  },
  {
    id: 's02',
    slug: 'certificate-of-residency',
    title: 'Certificate of Residency',
    group: 'Personal Certificates',
    icon: 'Home',
    purpose: 'School enrollment, bank transaction, employment',
    requirements: ['Valid government-issued ID', '2 × 1 ID picture (optional)'],
    fee: 'Php 40.00',
    processing: '1 working day',
  },
  {
    id: 's03',
    slug: 'certificate-of-indigency',
    title: 'Certificate of Indigency',
    group: 'Personal Certificates',
    icon: 'HandHeart',
    purpose: 'Medical / hospital assistance, burial assistance, scholarships',
    requirements: ['Valid government-issued ID', 'Proof of need (medical abstract, etc.)'],
    fee: 'Free',
    processing: 'Same day',
  },
  {
    id: 's04',
    slug: 'first-time-job-seeker',
    title: 'First Time Job Seeker Certificate',
    group: 'Personal Certificates',
    icon: 'Briefcase',
    purpose: 'Issued to first-time job seekers as basis for RA 11261 benefits',
    requirements: ['Valid ID', 'Oath of undertaking', 'PSA birth certificate'],
    fee: 'Free (RA 11261)',
    processing: 'Same day',
  },
  {
    id: 's05',
    slug: 'business-clearance',
    title: 'Business Barangay Clearance',
    group: 'Business-Related',
    icon: 'Store',
    purpose: 'Requirement for mayor’s permit and business registration',
    requirements: ['Valid ID', 'DTI / SEC registration', 'Lease contract or land title', 'Sketch of business location'],
    fee: 'Php 300.00 – 1,000.00 (depending on capitalization)',
    processing: '2 – 3 working days',
  },
  {
    id: 's06',
    slug: 'blotter-certification',
    title: 'Incident / Blotter Certification',
    group: 'Incident & Legal',
    icon: 'ScrollText',
    purpose: 'Official record of incident reported to barangay',
    requirements: ['Valid ID', 'Narrative of incident'],
    fee: 'Free',
    processing: 'Same day (for records only)',
  },
];

export const CONCERN_CATEGORIES = [
  'Road damage',
  'Drainage / flooding',
  'Broken streetlight',
  'Garbage / sanitation',
  'Illegal dumping',
  'Illegal parking / obstruction',
  'Noise complaint',
  'Stray animal concern',
  'Public safety concern',
  'Barangay service complaint',
  'Other concern',
];

export const EMERGENCY_CONTACTS = [
  { label: 'Barangay Hotline', number: '(02) 8655-1234', type: 'barangay', description: '24/7 barangay duty desk' },
  { label: 'Tanod Desk', number: '0917-555-7788', type: 'barangay', description: 'Peace and order assistance' },
  { label: 'Barangay Health Center', number: '(02) 8655-1235', type: 'health', description: 'BHW, first aid, referrals' },
  { label: 'Cainta Municipal Police (PNP)', number: '(02) 8655-0150', type: 'police', description: 'Emergency police response' },
  { label: 'Cainta Bureau of Fire Protection (BFP)', number: '(02) 8655-0222', type: 'fire', description: 'Fire and rescue' },
  { label: 'Rizal Provincial Ambulance', number: '0917-800-4411', type: 'medical', description: 'Ambulance and medical transport' },
  { label: 'Cainta Disaster Response', number: '(02) 8655-9911', type: 'disaster', description: 'Flood, typhoon, evacuation' },
  { label: 'Meralco Emergency', number: '16211', type: 'utility', description: 'Electrical emergencies' },
  { label: 'Manila Water', number: '1627', type: 'utility', description: 'Water supply emergencies' },
  { label: 'National Emergency Hotline', number: '911', type: 'national', description: 'All emergencies' },
];

export const DOWNLOADABLE_FORMS = [
  { id: 'f01', title: 'Barangay Clearance Request Form', size: '180 KB', updated: '2026-10-12', type: 'PDF' },
  { id: 'f02', title: 'Certificate of Indigency Request Form', size: '165 KB', updated: '2026-10-12', type: 'PDF' },
  { id: 'f03', title: 'Certificate of Residency Request Form', size: '155 KB', updated: '2026-10-12', type: 'PDF' },
  { id: 'f04', title: 'Business Clearance Checklist & Form', size: '240 KB', updated: '2026-09-28', type: 'PDF' },
  { id: 'f05', title: 'Program Registration Form (generic)', size: '120 KB', updated: '2026-08-15', type: 'PDF' },
  { id: 'f06', title: 'Complaint / Concern Form', size: '140 KB', updated: '2026-08-10', type: 'PDF' },
  { id: 'f07', title: 'Facility Use Request Form (Covered Court)', size: '130 KB', updated: '2026-07-22', type: 'PDF' },
];

export const STATUS_OPTIONS = {
  request: [
    'Submitted',
    'For Review',
    'Incomplete Requirements',
    'Approved',
    'Ready for Pickup',
    'Released',
    'Rejected',
    'Cancelled',
  ],
  concern: [
    'Submitted',
    'For Verification',
    'For Action',
    'In Progress',
    'Resolved',
    'Closed',
    'Referred',
    'Invalid / Duplicate',
  ],
};

// Seed sample data for admin dashboard (used if localStorage empty)
export const SAMPLE_REQUESTS = [
  { id: 'R-261128-AB12C', type: 'Barangay Clearance', name: 'Juan Dela Cruz', email: 'juan@example.com', status: 'For Review', date: '2026-11-28', purpose: 'Employment' },
  { id: 'R-261127-XY9PQ', type: 'Certificate of Indigency', name: 'Maria Santos', email: 'maria@example.com', status: 'Approved', date: '2026-11-27', purpose: 'Medical Assistance' },
  { id: 'R-261126-LK3MN', type: 'Business Clearance', name: 'Roberto Lim', email: 'roberto@example.com', status: 'Ready for Pickup', date: '2026-11-26', purpose: 'Sari-sari store renewal' },
  { id: 'R-261125-GH7JK', type: 'Certificate of Residency', name: 'Angela Reyes', email: 'angela@example.com', status: 'Released', date: '2026-11-25', purpose: 'Bank account opening' },
  { id: 'R-261124-WP5QR', type: 'First Time Job Seeker', name: 'Mark Tan', email: 'mark@example.com', status: 'Submitted', date: '2026-11-24', purpose: 'Employment application' },
];

export const SAMPLE_CONCERNS = [
  { id: 'C-261128-TR4FG', category: 'Broken streetlight', location: 'Purok 3, A. Bonifacio Ave.', urgency: 'Normal', status: 'For Action', date: '2026-11-28', name: 'Anonymous' },
  { id: 'C-261127-BN8KL', category: 'Drainage / flooding', location: 'Purok 4, corner Rizal St.', urgency: 'Urgent', status: 'In Progress', date: '2026-11-27', name: 'Linda Gonzales' },
  { id: 'C-261125-MX9ZA', category: 'Garbage / sanitation', location: 'Purok 7', urgency: 'Normal', status: 'Resolved', date: '2026-11-25', name: 'Ramon Cruz' },
  { id: 'C-261123-QW6ER', category: 'Noise complaint', location: 'Purok 2', urgency: 'Normal', status: 'Closed', date: '2026-11-23', name: 'Anonymous' },
];

export const CHART_REQUEST_TREND = [
  { month: 'Jun', clearance: 68, indigency: 42, business: 12, residency: 34 },
  { month: 'Jul', clearance: 72, indigency: 48, business: 15, residency: 30 },
  { month: 'Aug', clearance: 81, indigency: 55, business: 18, residency: 40 },
  { month: 'Sep', clearance: 76, indigency: 60, business: 14, residency: 38 },
  { month: 'Oct', clearance: 92, indigency: 58, business: 22, residency: 44 },
  { month: 'Nov', clearance: 104, indigency: 68, business: 26, residency: 52 },
];

export const CHART_CONCERN_CATEGORY = [
  { name: 'Streetlight', value: 42 },
  { name: 'Drainage', value: 38 },
  { name: 'Garbage', value: 28 },
  { name: 'Road damage', value: 22 },
  { name: 'Noise', value: 14 },
  { name: 'Other', value: 18 },
];
